<template>
  <b-container fluid class="month-control">
    <b-row class="widget-label">
      <b-col cols="3" style="padding: 0">
        <p class="label" v-if="!checkRoute">Survey</p>
      </b-col>
      <b-col cols="6" class="months-nav" v-if="monthControl">
        <b-button
          v-if="prevInterval"
          class="prev-month"
          @click="loadPrevInterval"
        >
          <b-icon icon="chevron-left"></b-icon>
        </b-button>
        <p class="label">{{ currentInterval }}</p>
        <b-button
          v-if="nextInterval"
          class="next-month"
          @click="loadNextInterval"
        >
          <b-icon icon="chevron-right"></b-icon>
        </b-button>
      </b-col>

      <b-col cols="3"></b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "MonthControl",
  props: {
    currentInterval: { type: String, default: null },
    nextInterval: { type: String, default: null },
    prevInterval: { type: String, default: null },
    monthControl: { type: Boolean, default: true },
  },
  data() {
    return {
      monthList: "1 Month",
      monthOptions: ["1 Month", "3 Month", "6 Month"],
      /*
      events: {
        'ready': () => {
          //var container = document.getElementById('question-chart');
            
          this.$helpers.handleAxisText(container);
          this.$helpers.handleGridlines(container);
        }
      }
      */
    };
  },
  methods: {
    loadPrevInterval() {
      this.$emit("update", {
        period: this.prevInterval,
      });
    },
    loadNextInterval() {
      this.$emit("update", {
        period: this.nextInterval,
      });
    },
  },
  computed: {
    checkRoute() {
      let path = this.$route.path;
      return path.includes("/evaluation") && path.includes("/result");
    },
  },
};
</script>
<style scoped>
.survey .month-control {
  border-width: 0 0 1px;
  border-color: #ebeff2;
  /* padding: 18px 15px 18px 25px; */
  width: 100%;
}
.survey .months-nav {
  display: flex;
  width: 100%;
  text-align: left;
  justify-content: center;
}
/* .widget-label {
  padding: 0px 0px 20px 0px;
} */
</style>